<div class="blocks-grid" [style.grid-template-rows]="blockRowsStyle">
  @for (block of blockIdentifiers.slice(0, countToShow); track block) {
    <div class="blocks-grid__item">
      <app-block [identifier]="block"></app-block>
    </div>
  }
</div>
